// import React, { Component } from "react";

import { fetchTimeInterval, getCurrentDate, getCurrentTime, isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { ItentificationTypeOptions } from "../../../../../../utils/constant";
import { computationRules1 } from "./DrugScreenCollection";
import { fetchProviderList } from "./NonDOTExamBPVisionAudio1";

const DrugScreenPanelActivity = (panelNo, variant = 'standard')=>{
    if(variant === 'EZ-Reader'){
        return [
            {label:'1. Amphetamines (AMP)',name:'amphetamine'},
            {label:'2. Barbiturates (BAR)',name:'barbiturates'},
            {label:'3. Benzodiazepines (BZD)',name:'benzodiazepines'},
            {label:'4. Buprenorphine (BUP)',name:'buprenorphine'},
            {label:'5. Cocaine (COC)',name:'cocaine'},
            {label:'6. Ecstasy (MDMA)',name:'ecstasy'},
            {label:'7. Fentanyl (FEN)',name:'fentanyl'},
            {label:'8. Marijuana (THC)',name:'marijuana'},
            {label:'9. Methadone (MTD)',name:'methadone'},
            {label:'10. Methamphetamines (MET)',name:'methamphetamines'},
            {label:'11. Morphine (MOR)',name:'morphine'},
            {label:'12. Oxycodone (OXY)',name:'oxycodone'},
            {label:'13. Phencyclidine (PCP)',name:'phencyclidine'},
        ];
    }else if(panelNo===10 && variant === 'AH'){
        return [
            {label:'1. Amphetamines (AMP)',name:'amphetamine'},
            {label:'2. Benzodiazepines (BZO)',name:'benzodiazepines'},
            {label:'3. Buprenorphine (BUP)',name:'buprenorphine'},
            {label:'4. Cocaine (COC)',name:'cocaine'},
            {label:'5. Marijuana (THC)',name:'marijuana'},
            {label:'6. MDMA (MDA/MDMA)',name:'ecstasy'},
            {label:'7. Methadone (MTD)',name:'methadone'},
            {label:'8. Methamphetamines (MAMP)',name:'methamphetamines'},
            {label:'9. Morphine (MOP)',name:'morphine'},
            {label:'10. Oxycodone (OXY)',name:'oxycodone'},
        ]
    }else if(panelNo===10){
        return [
            {label:'1. Amphetamines (AMP)',name:'amphetamine'},
            {label:'2. Barbiturates (BAR)',name:'barbiturates'},
            {label:'3. Benzodiazepines (BZO)',name:'benzodiazepines'},
            {label:'4. Cocaine metabolite (COC)',name:'cocaine'},
            {label:'5. Marijuana (THC)',name:'marijuana'},
            {label:'6. Methadone (MTD)',name:'methadone'},
            {label:'7. MDA (MDA/MDMA)',name:'drug_mdma'},
            {label:'8. Opioids (OPI)',name:'opioids'},
            {label:'9. 6-Acetylmorphine (Heroin)',name:'acetylmorphine'},
            {label:'10. Phencyclidine (PCP)',name:'phencyclidine'},
            {label:'11. Propoxyphene (PPX)',name:'propoxyphene'},
            // {label:'3.Phencyclidine (PCP)',name:'phencyclidine'},
            // {label:'5.Methaqualone (MTQ)',name:'methaqualone'},
            // {label:'8.Barbiturates (BAR)',name:'barbiturates'},
            // {label:'10.Propoxyphene (PPX)',name:'propoxyphene'}
            ]
    }else if(panelNo===12){
        return [
            {label:'1. Amphetamine (AMP)',name:'amphetamine'},
            {label:'2. Barbiturates (BAR)',name:'barbiturates'},
            {label:'3. Benzodiazepines (BZD)',name:'benzodiazepines'},
            {label:'4. Cocaine (COC)',name:'cocaine'},
            {label:'5. Ecstasy (MDMA)',name:'ecstasy'},
            {label:'6. Marijuana (THC)',name:'marijuana'},
            {label:'7. Methadone (MTD)',name:'methadone'},
            {label:'8. Methaqualone (MTQ)',name:'methaqualone'},
            {label:'9. Morphine (MOR)',name:'morphine'},
            {label:'10. Nortriptyline (TCA)',name:'nortriptyline'},
            {label:'11. Oxycodone (OXY)',name:'oxycodone'},
            {label:'12. Phencyclidine (PCP)',name:'phencyclidine'}
        ]
            // {label:'3.Phencyclidine (PCP)',name:'phencyclidine'},
            // {label:'5.Methaqualone (MTQ)',name:'methaqualone'},
            // {label:'6.Morphine (MOR)',name:'morphine'},
            // {label:'8.Nortriptyline (TCA)',name:'nortriptyline'},
            // {label:'11.Oxycodone (OXY)',name:'oxycodone'},
            // {label:'12.Ecstasy (MDMA)',name:'ecstasy'}
        
    }else if(panelNo===13){
        return [
            {label:'1. Amphetamines (AMP)',name:'amphetamine'},
            {label:'2. Barbiturates (BAR)',name:'barbiturates'},
            {label:'3. Benzodiazepines (BZO)',name:'benzodiazepines'},
            {label:'4. Cocaine metabolite (COC)',name:'cocaine'},
            {label:'5. Marijuana (THC)',name:'marijuana'},
            {label:'6. Methadone (MTD)',name:'methadone'},
            {label:'7. MDA (MDA/MDMA)',name:'drug_mdma'},
            {label:'8. Opioids (OPI)',name:'opioids'},
            {label:'9. Phencyclidine (PCP)',name:'phencyclidine'},
            {label:'10. Propoxyphene (PPX)',name:'propoxyphene'}
            // {label:'Fentanyl (FEN)',name:'fentanyl'},
            // {label:'Ecstasy (MDMA)',name:'ecstasy'},
            // {label:'Oxycodone (OXY)',name:'oxycodone'},
            // {label:'Buprenorphine (BUP)',name:'buprenorphine'},
            // {label:'Methamphetamines (MET)',name:'methamphetamines'},
            // {label:'Morphine (MOR)',name:'morphine'},
            ]
    }else if(panelNo===4){
        return [
            {label:'1. Amphetamine (AMP)',name:'amphetamine'},
            {label:'2. Cocaine metabolite (COC)',name:'cocaine'},
            {label:'3. Opioids (OPI)',name:'opioids'},
            {label:'4. Phencyclidine (PCP)',name:'phencyclidine'}]
    }else if(panelNo===5){
        return [
            {label:'1. Amphetamines (AMP)',name:'amphetamine'},
            {label:'2. Cocaine metabolite (COC)',name:'cocaine'},
            {label:'3. Marijuana (THC)',name:'marijuana'},
            {label:'4. Opioids (OPI)',name:'opioids'},
            {label:'5. Phencyclidine (PCP)',name:'phencyclidine'}]
    }else if(panelNo===7){
        return [
            {label:'1. Amphetamines (AMP)',name:'amphetamine'},
            {label:'2. Cocaine metabolite (COC)',name:'cocaine'},
            {label:'3. Marijuana (THC)',name:'marijuana'},
            {label:'4. Opiates (OPI)',name:'opiates'},
            {label:'5. Opioids (OPI-SYN)',name:'opioids'},
            {label:'6. Oxycodones (OXY)',name:'oxycodone'},
            {label:'7. Phencyclidine (PCP)',name:'phencyclidine'},
        
        ]
    }else if(panelNo===9){
        return [
            {label:'1. Amphetamines (AMP)',name:'amphetamine'},
            {label:'2. Barbiturates (BAR)',name:'barbiturates'},
            {label:'3. Benzodiazepines (BZO)',name:'benzodiazepines'},
            {label:'4. Cocaine metabolite (COC)',name:'cocaine'},
            {label:'5. Methadone (MTD)',name:'methadone'},
            {label:'6. MDA (MDA/MDMA)',name:'drug_mdma'},
            {label:'7. Opioids (OPI)',name:'opioids'},
            {label:'8. 6-Acetylmorphine (Heroin)',name:'acetylmorphine'},
            {label:'9. Phencyclidine (PCP)',name:'phencyclidine'},
            {label:'10. Propoxyphene (PPX)',name:'propoxyphene'},
            // {label:'4.Methaqualone (MTQ)',name:'methaqualone'},
            // {label:'6.Morphine (MOR)',name:'morphine'},
        ]
    }else if(panelNo===11){
        return [
            {label:'1. Barbiturates (BAR)',name:'barbiturates'},
            {label:'2. Benzodiazepines (BZO)',name:'benzodiazepines'},
            {label:'3. Cocaine metabolite (COC)',name:'cocaine'},
            {label:'4. Ecstasy (MDMA)',name:'ecstasy'},
            {label:'5. Marijuana (THC)',name:'marijuana'},
            {label:'6. Methadone (MTD)',name:'methadone'},
            {label:'7. Methamphetamines (MAMP)',name:'methamphetamines'},
            {label:'8. Opiates (OPI)',name:'opiates'},
            {label:'9. Oxycodone/Oxymorphone (OXY)',name:'oxycodone'},
            {label:'10. Phencyclidine (PCP)',name:'phencyclidine'},
            {label:'11. Propoxyphene (PPX)',name:'propoxyphene'},
        ]
    }
    else{
        return [];
    }
   
}
export const NewDrugScreenRapidPanel = (props,panelNo,type='others',variant='standard')=>{
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: true,
      };
    //console.log(' DrugScreenRapidPanel props',props);
    const typeOfScreenOptions = ['Pre-employment','Periodic Medical','Followup','Random','Promotion','Post Accident','Transfer','Return to Duty','Reasonable Suspicion/Cause','Diversion','Other'];
    let typeOfScreenOptionsArr = panelNo === 13 && type !== 'EZ-Reader'? [...typeOfScreenOptions, 'Fishing License']: typeOfScreenOptions;
    let includedSection  = [];
    let includedSectionTypeOfScreen = [];
    if(type!=='EZ-Reader'){
        includedSectionTypeOfScreen =[{
                label:'Reason',
                type:'SelectList',
                name:'reason',
                id:'reason',
                required:true,
                options:optionsToKeyValuePairs(typeOfScreenOptionsArr),
                required:true
            },
            {
                // label:'Specify Other Reason Time',
                isLabel:false,
                type:'TextArea',
                col:'col-6',
                name:'other_reason',
                placeholder:'Specify Other Reason',
                id:'other_reason',
                rules:[{rule:[{field:'reason',value:'Other',operator:'!=='}],action:'DISABLE'}],
                required:true
            }
            ,
            {
                label:"Sample ID",
                isLabel:true,
                type:'',
                col:'col-6',
                name:'sample_id',
                placeholder:'Sample ID',
                id:'sample_id',
            }
            
        ];
        includedSection=[ 
        {
            label:'Signs of Adulteration',
            note:'specimen temperature must be read within 4 minutes of collection.',
            col:'col-12',
            fields:[{
                label:'Signs of adulteration include:',
                notes:['unusual color','unusual smell','foreign objects in specimen','unusual behavior by donor'],
                type:'YesOrNoTable',
                options:[{label:'Yes',value:1},{label:'No',value:0}],
                defaultBtnLabel:'Set all to Normal',
                defaultValues:{new_adulteration_signs:0,sufficient_quantity:1,temperature_range:1},
                 list:[
                    {label:'Any sign of adulteration?',name:'new_adulteration_signs',failedValue:[1]},
                    {label:'In temperature range?',name:'temperature_range',failedValue: [0]},
                    {label:'Is there a sufficient quantity?',name:'sufficient_quantity',failedValue:[0]},
                ],
            },
        ]
        }];
    }
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails 
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'testing_details',
                label:'Result Details',
                data:[{
                    label:'Testing Details',                
                    labelStyle: "fw-semibold",
                    fieldProps: stackedFieldStyle,
                    fields:[{
                        label:'Arrival Date',
                        type:'Date',
                        name:'arrival_date',
                        required:true,
                        col:'col-6 border-0',
                    },
                    {
                        label:'Arrival Time',
                        name:'arrival_time',
                        type: "SelectSearchList",
                        placeholder:'Time',
                        isAsync:true,
                        options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                        loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                        required:true,
                        col:'col-6 border-0',
                    },
                    {
                        label:'Donor ID',
                        type:'SelectList',
                        options:ItentificationTypeOptions,
                        name:'donor_id',
                        required:true,
                        col:'col-6 border-0',
                    },
                    {
                        label:'Donor ID Number',
                        type:'TextInput',
                        name:'donor_id_number',
                        required:true,
                        placeholder:'Donor ID Number',
                        col:'col-6 border-0',
                    },
                    {
                        label:"Sample ID",
                        type:'TextInput',
                        name:'sample_id',
                        placeholder:'Sample ID',
                        id:'sample_id',
                        col:'col-6 border-0',
                    },
                    {
                        label:'Cup ID',
                        type:'TextInput',
                        name:'cup_id',
                        placeholder:'Cup ID',
                        col:'col-6 border-0',
                        disabled:true
                    },
                    {
                        label:'Drug Tests to be Performed',
                        type:'RadioGroup',
                        name:'drugs_tests',
                        id:'drugs_tests',
                        options:['Urine','Oral Fluid'],
                        required:true,
                        layout:'stacked',
                        col:'col-6 border-0',
                    },
                    props.formData.ez_file?{
                        label:'Test Image',
                        type:'FileType',
                        actionType:"openNewTab",
                        name:'ez_file',
                        file:props.formData.filemanager,
                        required:true,
                    }
                    :
                    null,
                    {
                        label:'Chain of Custody No',
                        type:'TextInput',
                        name:'chain_of_custody_no',
                        placeholder:'Chain of Custody No',
                        required:true,
                        col:'col-6 border-0',
                    },
                    {
                        label:'Reason',
                        type:'SelectList',
                        name:'reason',
                        id:'reason',
                        required:true,
                        options:optionsToKeyValuePairs(typeOfScreenOptionsArr),
                        required:true,
                        col:'col-6 border-0',
                    },
                    {
                        label:'Specify Other Reason',
                        type:'TextArea',
                        col:'col-6 border-0',
                        name:'other_reason',
                        placeholder:'Specify Other Reason',
                        id:'other_reason',
                        rules:[{rule:[{field:'reason',value:'Other',operator:'!=='}],action:'DISABLE'}],
                        required:true
                    },
                ]
                },
                {
                    label:'Add Comments / Incident Notes ',
                    labelStyle: "fw-semibold",
                    fieldProps: stackedFieldStyle,
                    fields:[
                        {
                            col:'col-12',
                            type: "TextArea",
                            label: "Notes",
                            placeholder: "Add Comments",
                            className: "form-control form-control-solid",
                            name: "notes",
                            col: "col-12 border-0",
                            max: 1000,
                        },
                  ]
                },
                {
                    label:'Activity Details - '+props.activityName,
                    labelStyle: "fw-semibold",
                    isLabel:false,
                    fields:[
                    {
                        col:'col-12',
                        label:'Activity Details - '+props.activityName,
                        type:'NewYesOrNo',
                        notes:['Select "Not Started" if testing has not begun.','Select "Positive" if any drug test is positive.','Select "Negative" if all drug tests are negative.'],
                        defaultBtnLabel:'All Negative',
                        defaultValues:DrugScreenPanelActivity(panelNo, variant).reduce((acc, itm) => {
                            acc[itm.name] = 'NEGATIVE';
                            return acc;
                        }, {}),
                        type:'NewYesOrNoTable',
                        options:[{label:'NOT STARTED',value:'NOT STARTED'},{label:'POSITIVE',value:'POSITIVE'},{label:'NEGATIVE',value:'NEGATIVE'}],
                        list:DrugScreenPanelActivity(panelNo, variant),
                        
                    },
                ] 
                },
                {
                      label:'Signs of Adulteration',
                      labelStyle: "fw-semibold",
                      note:'specimen temperature must be read within 4 minutes of collection.',
                      col:'col-12',
                      rules:[{rule:[{field:'drugs_tests',value:'Oral Fluid',operator:'==='}],action:'HIDE'}],
                      fields:[
                            {
                                type:'AdulterationForm',
                                label:'Signs of adulteration include:',
                                notes:['unusual color','unusual smell','foreign objects in specimen','unusual behavior by donor'],
                            },
                            {
                              label:'Signs of adulteration',
                              notes:['unusual color','unusual smell','foreign objects in specimen','unusual behavior by donor'],
                              type:'NewYesOrNoTable',
                              options:[{label:'Yes',value:1},{label:'No',value:0}],
                              defaultBtnLabel:'All Normal',
                              defaultValues:{new_adulteration_signs:0,sufficient_quantity:1,temperature_range:1},
                              list:[
                                   {label:'Any sign of adulteration?',name:'new_adulteration_signs',failedValue:[1]},
                                   {label:'In temperature range?',name:'temperature_range',failedValue: [0]},
                                   {label:'Is there a sufficient quantity?',name:'sufficient_quantity',failedValue:[0]},
                                   ],
                            }]
                },
                {
                      label:'Result Date & Time',
                      labelStyle: "fw-semibold",
                      fieldProps: stackedFieldStyle,
                      note:'',
                      col:'col-12',
                       fields:[{
                        label:'Result Date',
                        type:'Date',
                        name:'result_date',
                        col:'col-6 border-0',
                    },
                    {
                        label:'Result Time',
                        name:'result_time',
                        placeholder:'Time',
                        type: "SelectSearchList",
                        isAsync:true,
                        options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                        loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                        col:'col-6 border-0',
                    }]
                },
                {
                    label:'Shipping Information',
                    labelStyle: "fw-semibold",
                    fieldProps: stackedFieldStyle,
                    col:'col-6',
                    fields:[{
                        label:'Shipping Service',
                        type:'SelectList',
                        options:isSet(props.lookupsOptions['shippingService'],[]),
                        name:'shipping_service',
                        col:'col-6 border-0',
                    },
                    {
                        label:'Shipping Billing No.',
                        type:'TextInput',
                        placeholder:'Shipping Billing No.',
                        name:'shipping_billing_no',
                        col:'col-6 border-0',
                    },
                  
                ]
                },
                {
                    label: "Review / Completion",
                    labelStyle: "fw-semibold",
                    fields: [
                        {
                            type: "ProviderSignOff",
                            col: "col-12",
                            fields: [
                                { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                                { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                                { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                                // Previous options:
                                // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending Result','Confirmatory Pending','Non-Negative','Negative','Confirmed Negative','Confirmed Positive',],false),statusBasedColor: true },
                                // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','In Progress','Pending confirmation','Pending MRO Review','Passed','Failed','Cancelled'],false),statusBasedColor: true },
                                // New standard options:
                                { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive'],false),statusBasedColor: true,},
                                { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled'],false),statusBasedColor: true },
                            ],
                        },
                    ],
                }
            ]
            },
            {
                id:'LabDetailsMROReview',
                label:'Lab Details / MRO Review',
                data:[
                    {
                        label:'Lab Details',
                        labelStyle: "fw-semibold",
                        fieldProps: stackedFieldStyle,
                        fields:[
                            {
                                label:'Lab Name',
                                type:'TextInput',
                                Max:200,
                                name:'lab_name',
                                placeholder:'Lab Name',
                                col:'col-6 border-0',
                            },
                            {
                                label:'Lab Specimen Received Date',
                                name:'lab_received_date',
                                type: "Date",
                                placeholder:'Date',
                                col:'col-6 border-0',
                            },
                            {
                                label:'Lab Specimen Received Time',
                                name:'lab_received_time',
                                type: "SelectSearchList",
                                placeholder:'Time',
                                options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                                loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                                col:'col-6 border-0',
                                isAsync:true,
                            }, 
                            {
                                label:'Lab Reported Date',
                                name:'lab_reported_date',
                                type: "Date",
                                placeholder:'Date',
                                col:'col-6 border-0',
                            },
                            {
                                label:'Lab Reported Time',
                                name:'lab_reported_time',
                                type: "SelectSearchList",
                                placeholder:'Time',
                                options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                                loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                                col:'col-6 border-0',
                                isAsync:true,
                            }, 
                        ],
                    },
                    {
                        label:'MRO Review Determination',
                        labelStyle: "fw-semibold",
                        fieldProps: stackedFieldStyle,
                        fields:[
                            {
                                label:'MRO Verification Status',
                                type:'SelectList',
                                options: optionsToKeyValuePairs([
                                    'Not Started',
                                    'Pending Lab Result',
                                    'Pending MRO Review',
                                    'Under Review',
                                    'Verified Negative',
                                    'Verified Positive',
                                    'Cancelled'
                                ]),                                
                                name:'mro_verification_status',
                                col:'col-4 border-0',
                            },
                            {
                                label:'MRO Verified Result',
                                type:'SelectList',
                                options: optionsToKeyValuePairs([
                                    'Negative',
                                    'Positive',
                                    'Cancelled',
                                    'Inconclusive',
                                    'Pending',
                                    'Refused',
                                    'Invalid',
                                    'Dilute'
                                ]),
                                name:'mro_verified_result',
                                placeholder:'MRO Verified Result',
                                col:'col-4 border-0',
                            },
                            {
                                label: "Verified By (Medical Review Officer)",
                                type: 'SelectSearchList',
                                isAutoPopulate: true,
                                placeholder: 'Medical Review Officer',
                                isAsync: true,
                                options: [],
                                loadCallBack: (val, callback) => fetchProviderList(val, props, callback),
                                name: 'verified_by',
                                id: 'verified_by',
                                col: 'col-4 border-0',
                            },
                            {
                                label:'Verification Date',
                                name:'verification_date',
                                type: "Date",
                                placeholder:'Date',
                                col:'col-4 border-0',
                            },
                            {
                                label:'Verification Time',
                                name:'verification_time',
                                type: "SelectSearchList",
                                placeholder:'Time',
                                options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                                loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                                col:'col-4 border-0',
                                isAsync:true,
                            },
                            {
                                label:'Signed Date',
                                name:'mro_signed_date',
                                type: "Date",
                                placeholder:'Date',
                                col:'col-4 border-0',
                            },
                            {
                                label:'Signed Time',
                                name:'mro_signed_time',
                                type: "SelectSearchList",
                                placeholder:'Time',
                                options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                                loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                                col:'col-4 border-0',
                                isAsync:true,
                            },
                            { 
                                label : "ReviewStatus", 
                                type: "SelectList", 
                                name: "review_status", 
                                col: "col-4 border-0", 
                                options: optionsToKeyValuePairs([
                                    'Not Started',
                                    'Pending',
                                    'In Review',
                                    'Completed',
                                    'Cancelled'
                                ],false),                                
                                statusBasedColor: true 
                            },

                        ],
                    },
                ],
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    
    const defaultValue = {
        arrival_date:props.visitDetails.visit_date,
        arrival_time:props.visitDetails.visit_time,
        result_date:'',
        result_time:'',
        donor_id:isSet(props.employeeDetails.identification_type,''),
        donor_id_number:isSet(props.employeeDetails.identification_number,''),
        dot_agency:'FMCSA',
        cup_id:props.visitDetails.cup_id,
        collection_type:'Single',
        drugs_tests:'Urine',
        reason:(panelNo === 13 && type !== 'EZ-Reader')?'Fishing License':'',
        status:'Not Started',
        activity_status:'Not Started',
        suggested_status:'Not Started',
        ...DrugScreenPanelActivity(panelNo, variant).reduce((acc, itm) => {
            acc[itm.name] = 'NOT STARTED';
            return acc;
        }, {})
    };
    const buttons = {
        label: false,
        result: false,
        showDrugScreenPrintActions: true,
    };
    const headers = [];
    return {
        charts,
        defaultValue, 
        buttons,
        headers,
        computationFunction: (formData,key) => ({
            ...computationRules(panelNo,type,formData,key,variant),
            ...computationRules1(formData,key),
        })
    };
}

const computationRules = (panelNo,type,formData,key='',variant='standard')=>{
    // const DrugPannelValues = DrugScreenPanelActivity(panelNo, variant).reduce((acc, itm) => {
    //     acc[itm.name] = formData[itm.name];
    //     return acc;
    // }, {});
    // let updatedOtherReason=formData['other_reason'];
    // if (key=='reason'&&formData[key]!='Other') {
    //     updatedOtherReason='';
    // }
    // const anyNotStarted = Object.values(DrugPannelValues).some(value => value === 'NOT STARTED');
    // const anyPositive = Object.values(DrugPannelValues).some(value => value === 'POSITIVE');
    // const allNegative = Object.values(DrugPannelValues).every(value => value === 'NEGATIVE');
    // const allNonStarted = Object.values(DrugPannelValues).every(value => value === 'NOT STARTED');

    // const adulteration = {new_adulteration_signs:0,sufficient_quantity:1,temperature_range:1};
    // // console.log('adulteration',adulteration);

    // let adulterationEqual = Object.entries(adulteration).every(([key, value]) => formData[key] === value);
    // // console.log('adulterationEqual',adulterationEqual);
    // let adulterationChecked = isSet(formData.new_adulteration_signs) ||isSet(formData.sufficient_quantity) ||isSet(formData.temperature_range); 

    // if(type==='EZ-Reader'){
    //     adulterationEqual = true;
    // }
    // let status = '';

    // // Chart Status Computation
    // if (anyPositive) {
    //     status = 'Pending MRO';
    // } else if (allNegative && adulterationEqual) {
    //     status = 'Passed';
    // } else if (adulterationChecked ||  adulterationEqual===false) {
    //     status = 'Pending';
    // } else if (adulterationEqual===false || !adulterationChecked) {
    //     status = 'Not Started';
    // }
    // return (key==='status')?{}:{'status':status,'suggested_status':status,'other_reason':updatedOtherReason};

    // if(key==='status' && formData.status==='Not Started' ){
    //     return {
    //       status: 'Not Started',
    //       activity_status: 'Not Started'
    //     };
    //   }
    //   if(key==='status' && formData.status==='Pending Result' ){
    //     return {
    //       activity_status: 'In Progress'
    //     };
    //   }
    //   if(key==='status' && formData.status==='Negative'){
    //     return {
    //       activity_status: 'Passed'
    //     };
    //   }
    //   if(key==='status' && formData.status==='Non-Negative'){
    //     return {
    //       activity_status: 'Pending confirmation'
    //     };
    //   }
    //   if(key==='status' && formData.status==='Confirmatory Pending'){
    //     return {
    //       activity_status: 'In Progress'
    //     };
    //   }
    //   if((key==='status' || key==='provider_signature') && (formData.status==='Confirmed Negative'||formData.status==='Confirmed Positive') && (formData.provider_signature==='' || formData.provider_signature===null || formData.provider_signature===undefined)){
    //     return {
    //       activity_status: 'Pending MRO Review'
    //     };
    //   }
    //   if((key==='provider_signature' || key==='status') && (formData.provider_signature!='' && formData.provider_signature!=null && formData.provider_signature!=undefined) && formData.status==='Confirmed Negative'){
    //     return {
    //       activity_status: 'Passed'
    //     };
    //   }
    //   if((key==='provider_signature' || key==='status') && (formData.provider_signature!='' && formData.provider_signature!=null && formData.provider_signature!=undefined) && formData.status==='Confirmed Positive'){
    //     return {
    //       activity_status: 'Failed'
    //     };
    //   }
    // Avoid feedback loops when status or activity_status themselves are being changed
    if (key === "status" || key === "activity_status" || key === "provider_signature") {
        return {};
    }

    // Urine-only adulteration fields are hidden for Oral Fluid; reset whenever test type changes
    // so stale values are not saved, and switching Oral → Urine does not show prior selections.
    const adulterationReset =
        key === "drugs_tests"
            ? {
                  new_adulteration_signs: "",
                  temperature_range: "",
                  sufficient_quantity: "",
              }
            : {};

    let returnResult = { ...adulterationReset };

    // Get all drug panel values
    const DrugPannelValues = DrugScreenPanelActivity(panelNo, variant).reduce((acc, itm) => {
        acc[itm.name] = formData[itm.name];
        return acc;
    }, {});
    console.log('DrugPannelValues',key);
    // Check if all drug test values are POSITIVE
    const allPositive = Object.values(DrugPannelValues).every(value => value === 'POSITIVE');
    const hasAnyValue = Object.values(DrugPannelValues).some(value => value && value !== 'NOT STARTED');
    const allNegative = Object.values(DrugPannelValues).every(value => value === 'NEGATIVE');
    const allNotStarted = Object.values(DrugPannelValues).every(value => value === 'NOT STARTED');

    // If all values are POSITIVE, set status to "Non-Negative" and activity_status to "In Progress"
    if (allPositive && hasAnyValue) {
        returnResult.status = "Non-Negative";
        returnResult.activity_status = "Pending MRO Confirmation";
        return returnResult;
    }else if (allNegative && hasAnyValue) {
        returnResult.status = "Negative";
        returnResult.activity_status = "Completed";
        return returnResult;
    }else if (hasAnyValue && !allPositive && !allNegative) {
        returnResult.status = "Pending";
        returnResult.activity_status = "Pending";
        return returnResult;
    }

    const currentStatus = isSet(formData.status, "Not Started");
    const currentActivityStatus = isSet(formData.activity_status, "Not Started");

    // If user changes any field while both status and activity_status are "Not Started",
    // move to Pending Result / In Progress
    if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
        returnResult.status = "Pending";
        returnResult.activity_status = "Pending";
    }

    // Handle adulteration-based status calculation
    // const adulteration = {new_adulteration_signs:0,sufficient_quantity:1,temperature_range:1};
    // const adulterationEqual = Object.entries(adulteration).every(([key, value]) => formData[key] === value);
    
    // if(!isSet(key) 
    // || key === 'new_adulteration_signs' 
    // || key === 'temperature_range' 
    // || key === 'sufficient_quantity' 
    // || key === 'temperature_range_second_read'){
    //     if (adulterationEqual===true) {
    //         returnResult.status = 'Negative';
    //         returnResult.activity_status = 'Passed';
    //     }else{
    //         returnResult.status = 'Pending Result';
    //         returnResult.activity_status = 'In Progress';
    //     }
    // }

    return returnResult;
}




